// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23ODs","importantInfo":"styles_importantInfo__BSSDN"};